import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/mopz-casebg@2x-min.jpg';

export default {
  path: '/cases/mopz',
  color: variables.mopz,
  casebg,
  title: 'Mopz',
  headline: 'iOS & Android application',
  description: 'A social network, based on Augmented Reality',
  isWeb: false,
  isAndroid: false,
  textColor: variables.carbonBlack,
};
